const Translations = {
    namespaced: true,
    state: {
        items: [],
        namespaces: [],
        languages: [],
        updating: false,
    },
    getters: {
        all: (state) => {
            return state.items;
        },
    },
    mutations: {
        SET_UPDATING(state, data) {
            state.updating = data;
        },
        SET_ITEMS(state, data) {
            state.items = data;
        },
        SET_NAMESPACES(state, data) {
            state.namespaces = data;
        },
        SET_LANGUAGES(state, data) {
            state.languages = data;
        },
    },
    actions: {
        loadNamespaces({ commit }, filters) {
            axios.get(route('api.v1.translations.namespaces', filters)).then((response) => {
                commit('SET_NAMESPACES', response.data);
            });
        },
        loadLanguages({ commit }) {
            axios.get(route('api.v1.translations.languages')).then((response) => {
                commit('SET_LANGUAGES', response.data);
            });
        },
        updateTranslation({ commit }, data) {
            if (_.isUndefined(data.key)) {
                return Promise.reject(new Error(t('translations::errors.key.not_defined')));
            }

            if (_.isUndefined(data.value)) {
                return Promise.reject(new Error(t('translations::errors.value.not_defined')));
            }

            if (_.isUndefined(data.language)) {
                return Promise.reject(new Error(t('translations::errors.language.not_defined')));
            }

            commit('SET_UPDATING', true);

            return new Promise((resolve, reject) => {
                return axios
                    .put(route('api.v1.translations.update', { translation: data.key }), {
                        value: data.value,
                        language: data.language,
                        namespace_key: data.key,
                    })
                    .then((response) => {
                        return resolve(response);
                    })
                    .catch((error) => {
                        return reject(error);
                    })
                    .finally(() => {
                        commit('SET_UPDATING', false);
                    });
            });
        },
        storeBulkTranslations({ commit }, data) {
            return new Promise((resolve, reject) => {
                commit('SET_UPDATING', true);
                return axios
                    .put(route('api.v1.translations.bulk'), {
                        data: data,
                    })
                    .then((response) => {
                        return resolve(response);
                    })
                    .catch((error) => {
                        return reject(error);
                    })
                    .finally(() => {
                        commit('SET_UPDATING', false);
                    });
            });
        },
    },
};

export default Translations;
